<template>
  <div class="card modal-card">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ step !== 'RECAP' ? $t('popUpParametrageReseauTempoDispo.title')
              :$t('popUpParametrageReseauTempoDispo.titleRecap') }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content">
        <error-msg-component :messages="messages"
                             :error="error"
                             :title="'popUpParametrageReseauTempoDispo.errors.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
        <select-produit-loc-and-niveau-dispo v-if="step === 'PARAMETRAGE'"
                                             :produits-location="produitsLocation"
                                             :parametrage-selection="parametrageSelection"/>
        <select-dates v-if="step === 'SELECTDATES'"
                      :weeksSelect="weeksSelect"/>
        <recap v-if="step === 'RECAP'"
               :produits-location="produitsLocation"
               :etat-souhaite-select="parametrageSelection.etatSouhaiteSelect"
               :parametrage-selection="parametrageSelection"
               :weeks-select="weeksSelect"/>
        <footer class="mgt-20px">
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="beforeStep()">
                {{ step === 'PARAMETRAGE' ? $t('popUpParametrageReseauTempoDispo.actions.cancel')
                : $t('popUpParametrageReseauTempoDispo.actions.beforeStep') }}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <a class="button is-addOrEdit" @click="nextStep()">
                {{ step === 'RECAP'
                ? $t('popUpParametrageReseauTempoDispo.actions.createDevis')
                : $t('popUpParametrageReseauTempoDispo.actions.nextStep')}}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import messageErreur from '@/services/general/messageErreur';
import { getAll } from '@/api/produit/produitLocation';
import selectProduitLocAndNiveauDispo
  from '@/components/outils/reseauTempo/parametrageSelection/selectProduitLocAndNiveauDispo';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import selectDates from '@/components/outils/reseauTempo/parametrageSelection/selectDates';
import recap from '@/components/outils/reseauTempo/parametrageSelection/recap';
import { SET_LIGNES_COMMANDE, CLEAR_PANIER, SET_IS_FROM_LIST_RESEAU_TEMPO_DISPO } from '@/store/modules/produitReseauTempo-mutation-type';
import { PRODUIT_ID_LOCATION_PAR_DEFAUT } from '@/configuration/societe/societe';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const ProduitReseauTempo = createNamespacedHelpers('produitReseauTempo');
const Parametres = createNamespacedHelpers('parametres');
const Societes = createNamespacedHelpers('societe');

export default {
  props: {
    societeId: {
      type: String,
      required: true,
    },
    parametrageSelection: {
      type: Object,
      required: true,
    },
    weeksSelect: {
      type: Array,
      required: true,
    },
  },
  components: {
    selectProduitLocAndNiveauDispo,
    errorMsgComponent,
    selectDates,
    recap,
  },
  data() {
    return {
      produitsLocation: [],
      step: 'PARAMETRAGE',
      messages: [],
      error: false,
    };
  },
  computed: {
    ...ProduitReseauTempo.mapGetters({
      lignesCommande: 'lignesCommande',
      panier: 'panier',
    }),
    ...Societes.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
  },
  methods: {
    ...ProduitReseauTempo.mapMutations({
      setLignesCommandes: SET_LIGNES_COMMANDE,
      clearPanier: CLEAR_PANIER,
      setIsFromListReseauTempoDispo: SET_IS_FROM_LIST_RESEAU_TEMPO_DISPO,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    transformToDevis() {
      if (this.lignesCommande.length === 0) {
        this.error = true;
        this.messages.push({ message: 'popUpParametrageReseauTempoDispo.errors.lignesCommande' });
        return;
      }
      const lignes = cloneDeep(this.lignesCommande);
      lignes.forEach((ligne) => {
        ligne.etatSouhaite = this.parametrageSelection.etatSouhaiteSelect;
      });
      this.setLignesCommandes(lignes);
      this.clearPanier();
      this.setIsFromListReseauTempoDispo(true);
      this.$router.push({ name: 'm.bodac.devis-creation' });
    },
    beforeStep() {
      this.error = false;
      this.messages = [];
      switch (this.step) {
        case 'PARAMETRAGE':
          this.$parent.close();
          break;
        case 'RECAP':
          this.step = 'SELECTDATES';
          break;
        default:
          this.step = 'PARAMETRAGE';
      }
    },
    nextStep() {
      this.error = false;
      this.messages = [];
      switch (this.step) {
        case 'PARAMETRAGE':
          if (this.parametrageSelection.produitLoc === PRODUIT_ID_LOCATION_PAR_DEFAUT
            && this.allReseauHasLocation() === false) {
            this.getErreurByReseau();
            this.error = true;
            return;
          }
          if (!this.parametrageSelection.produitLoc) {
            this.error = true;
            this.messages.push({ message: 'popUpParametrageReseauTempoDispo.errors.produitLoc' });
            return;
          }
          this.step = 'SELECTDATES';
          break;
        case 'SELECTDATES':
          if (this.weeksSelect.length === 0) {
            this.error = true;
            this.messages.push({ message: 'popUpParametrageReseauTempoDispo.errors.weeksSelect' });
          } else this.step = 'RECAP';
          break;
        default:
          this.transformToDevis();
      }
    },
    allReseauHasLocation() {
      return !this.panier.some((reseau) => {
        return reseau.produitParDefautId === null;
      });
    },
    getErreurByReseau() {
      this.panier.forEach((reseau) => {
        if (!reseau.produitParDefautId) {
          this.messages.push({ message: 'popUpParametrageReseauTempoDispo.errors.reseauTempoWithoutDefautProduit', parametres: { libelle: reseau.libelle + ' - ' + reseau.reference } });
        }
      });
    },
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key]);
      let societeId = this.$route.params.id;
      if (this.filtrerProduitParSociete) societeId = this.societeActiveId;
      const queryItemLocation = {
        query: {
          societeId: societeId,
          actif: null,
        },
        orderBy: 'ProduitLocation.Quantite, Libelle',
        ascending: true,
        maxResultCount: NO_PAGINATION,
      };
      this.produitsLocation = (await getAll(queryItemLocation)).data.result.items;
      this.produitsLocation.push({ id: PRODUIT_ID_LOCATION_PAR_DEFAUT, libelle: this.$t('reseauTempo.briefContent.locationDefault') });
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
